module.exports = __webpack_public_path__ + "components/country-flag/static/eg-bd9c2184e7d2c39efda2f7d7fdf72f49.svg";